/**
 * Componente de Erro
 */

import React from 'react';
import { Box, Alert, AlertTitle, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';

interface ErrorMessageProps {
  message?: string;
  title?: string;
  onRetry?: () => void;
  fullScreen?: boolean;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message = 'Ocorreu um erro ao carregar os dados.',
  title = 'Erro',
  onRetry,
  fullScreen = false,
}) => {
  const content = (
    <Alert
      severity="error"
      action={
        onRetry && (
          <Button
            color="inherit"
            size="small"
            startIcon={<Refresh />}
            onClick={onRetry}
          >
            Tentar novamente
          </Button>
        )
      }
    >
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          width: '100%',
          p: 2,
        }}
      >
        <Box sx={{ maxWidth: 600, width: '100%' }}>{content}</Box>
      </Box>
    );
  }

  return <Box sx={{ py: 2 }}>{content}</Box>;
};